// extracted by mini-css-extract-plugin
export default {"panelContent":"panelContent__TE72D2"};